
import React, { useEffect, useState } from "react";
import "./Map.css";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useRecoilState } from "recoil";
import { atomobj } from "../C";
import { useNavigate } from "react-router-dom";
import Loader from "../Skleton/Loader"
import { url } from "../utils/baseurl";

function Earthquake() {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isScriptLoadSucceed, setIsScriptLoadSucceed] = useState(false);
  const [locs, setLocs] = useState([]);
  const [alertinfo, setAlertInfo] = useState([]);
  const [msgofatm, setmsgofatm] = useRecoilState(atomobj);
  const [earthquakeinfo, setEarthquakeInfo] = useState([]);



  const [isloading, setisloading] = useState(false)


  const nav = useNavigate();

  const handleScriptLoad = () => {
    setIsScriptLoaded(true);
  };

  const handleScriptError = () => {
    setIsScriptLoaded(false);
  };


  async function getEarthquake() {
    setisloading(true);
  
    try {
      const response = await fetch(
        `${url}/FetchEarthquakeAlerts`
      );
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const data = await response.json();
      console.log(data);
  
      // Extract earthquake data and add markers
      const earthquakeMarkers = data.alerts.map((earthquake) => {
        const { latitude, longitude } = earthquake.polygons[0];
        return {
          lat: parseFloat(latitude),
          lng: parseFloat(longitude),
        };
      });
  
      setLocs(earthquakeMarkers);
      setEarthquakeInfo(data.alerts);
    } catch (error) {
      console.error("Error fetching earthquake data:", error);
      // You can handle the error here, e.g., show an error message to the user.
    }
  
    setisloading(false);
  }
  

  useEffect(() => {
    if (isScriptLoaded) {
      setIsScriptLoadSucceed(true);
      getEarthquake();
    }
  }, [isScriptLoaded]);

  const mapContainerStyle = {
    width: "100%",
    height: "600px",
  };

  const center = {
    lat: 20.5937, // Latitude of India
    lng: 78.9629,
  };



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEarthquake, setSelectedEarthquake] = useState(null);
  // Other state and functions...

  const openModal = (earthquake) => {
    setSelectedEarthquake(earthquake);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedEarthquake(null);
    setIsModalOpen(false);
  };



  return (
    <>






      <div className="map-outer-box">
        {/* <h1>ALERT REGIONS</h1> */}
        <div className="map-inner-box">
          <LoadScript
            googleMapsApiKey="AIzaSyAPEgecVTqBmxZC1D6SIhcp01caAwqZj3I"
            onLoad={handleScriptLoad}
            onError={handleScriptError}
          >
            {isScriptLoadSucceed && (
              <>
         <GoogleMap
  mapContainerStyle={mapContainerStyle}
  center={center}
  zoom={3}
>
  {locs.map((markerData, index) => {
    // Ensure that markerData contains lat and lng properties
    const { lat, lng } = markerData;

    return (
      <Marker
        key={index}
        position={{ lat, lng }}
        icon={{
          url: "https://freesvg.org/img/1286146771.png",
          scaledSize: new window.google.maps.Size(10, 10),
        }}
      />
    );
  })}
</GoogleMap>
              </>
            )}
          </LoadScript>
        </div>

      </div>

      <br />

{isloading?<>



<Loader/>




</>:<>


{earthquakeinfo.length>0?<>




  <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >



      <i>(Tap on the particular region to get detailed info)</i>
      </div>
      <br />


      <div className="earthquake-info-container">
        {earthquakeinfo.map((item, index) => (
          <div
            className="earthquake-info-box cursor-pointer"
            key={index}
            onClick={() => openModal(item)}
          >
            <p>{item.magnitude} magnitude earthquake in {item.direction}</p>
          </div>
        ))}
      </div>






</>:<>





<div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >



      <i>NO LIVE EARTHQUAKE RIGHT NOW</i>
      </div>
      <br />





</>






}







      {isModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center z-50">
    <div className="bg-white w-96 p-4 rounded-lg shadow-md">
      <div className="text-red-500 text-xl font-bold mb-4">
        Alert           {selectedEarthquake.direction}

      </div>
      <div>
        <p>
          
          <strong>PLACE-</strong>{selectedEarthquake.magnitude} magnitude earthquake in{" "}{selectedEarthquake.direction} 

          <br />
          <hr />
            <strong>DATE-</strong> {selectedEarthquake.effective_start_time}
          <br />
          <hr />
            <strong> MESSAGE-</strong>{selectedEarthquake.warning_message
}
        </p>
      </div>
      <div className="mt-4">
        <button
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none"
          onClick={closeModal}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}











</>}

 


    </>
  );
}

export default Earthquake;
